import cx from 'classnames';
import { AsyncPaginate } from 'react-select-async-paginate';
import type { GroupBase } from 'react-select';
import type { AsyncPaginateProps } from 'react-select-async-paginate';
import type { AsyncProps } from 'react-select/async';

import css from './Select.module.less';

type AdditionalProps = {
  /**
   * Whether or not the left/right corners should not have a radius applied to them. Useful for when the select will be
   * right up against another component.
   */
  smooth?: 'left' | 'right';
};

/**
 * A wrapped react-select async select dropdown that provides our FOSSA stylings and a couple of QoL typing changes.
 */
const AsyncPaginatedSelect = <OptionType, Group extends GroupBase<OptionType>, Additional, IsMulti extends boolean>(
  props: Omit<AsyncPaginateProps<OptionType, Group, Additional, IsMulti>, 'onChange' | 'classNamePrefix'> & AdditionalProps & {
    // We have to override onChange to make it less miserable to work with.
    onChange: IsMulti extends true ? (e: OptionType[]) => void : (e: OptionType | null) => void;
  },
) => {
  return (
    <AsyncPaginate
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      onChange={props.onChange as AsyncProps<OptionType, IsMulti, Group>['onChange']}
      className={cx(css.fossaSelect, props.className, {
        [css.smoothLeft]: props.smooth === 'left',
        [css.smoothRight]: props.smooth === 'right',
      })}
      //  Note: we target these classes by using the :global() selector in Select.module.less
      classNamePrefix="fossa-select"
    />
  );
};

export default AsyncPaginatedSelect;
